import { isInputEmpty } from "@/utils/typeCheck";
import { maintainConsigneeOptions } from "@/api/options/lcl";
import { voyageFormat, str, negativeFormat, byKey } from "@/utils/tool";
// 存在二程转运
export function hasTransportation(detail) {
  if (detail && +detail.isTransfer === 1) {
    return true;
  } else return false;
  // if (detail && !isInputEmpty(detail.secondTransferId)) {
  //   return true;
  // } else return false;
}

// 存在二程转运固定费
export function hasTransportationFixedCharge(detail) {
  if (
    detail &&
    hasTransportation(detail) &&
    (!isInputEmpty(detail.transferPrice) ||
      !isInputEmpty(detail.transferPriceTon))
  ) {
    // 是使用转运固定费
    return true;
  } else {
    return false;
  }
}

// 展示航程
export function showVoyageInList(row, context = {}) {
  let resStr = [row.forwardVoyage, row.voyage, row.ltVoyage]
    .filter(item => !isInputEmpty(item))
    .map(item => voyageFormat(item))
    .join("+");
  return resStr ? `${resStr}${context.i18n.t("message.common.days")}` : "";
}

// 拼接航程天
export function joinVoyageList(list = [], locale = "cn") {
  // console.log("========== joinVoyageList", list, locale);
  let finalVoyage = "";
  if (!list || list.length <= 0) {
    return finalVoyage;
  }
  let hasValue = list.find(item => !isInputEmpty(item));
  if (!hasValue) {
    // 都是空
    return finalVoyage;
  }
  // 获取一组移除了天的
  let formatList = list.map(item => voyageFormat(item));
  let findNotNumber = formatList.find(item => isNaN(Number(item)));
  if (findNotNumber) {
    // 直接拼接
    finalVoyage = formatList.filter(item => !isInputEmpty(item)).join("+");
    finalVoyage += locale === "cn" ? "天" : " Days";
    return finalVoyage;
  } else {
    // calc
    let total = formatList.reduce((a, b) => {
      return Number(a) + Number(b);
    }, 0);
    finalVoyage = String(total) + (locale === "cn" ? "天" : " Days");
    // console.log("==========calc total", total, finalVoyage);
    return finalVoyage;
  }
}

// 表格价格显示
export function showTablePrice(row, priceKey, type = 1, currency) {
  let resStr = "";
  let resPrice = "";
  // type 1一程 2二程 currency币种
  if (type == 1) {
    if (hasTransportationFixedCharge(row)) {
      if (priceKey === "priceCbm") {
        resPrice = row.transferPrice;
      } else if (priceKey === "priceTon") {
        resPrice = row.transferPriceTon;
      }
    } else {
      resPrice = row[priceKey];
    }
    resStr = str(negativeFormat(resPrice), "", "${}");
  } else if (type == 2) {
    let resPrice = row[priceKey];
    resStr = str(negativeFormat(resPrice), "", "${}");
  }
  return resStr;
}
// 海运费用表格数据
export function oceanTransferTableData(row) {
  let list = [];
  let seaTableRow,
    transferRow = {};
  seaTableRow = {
    text: "海运费",
    textEn: "Ocean Freight",
    priceCbm: showTablePrice(row, "priceCbm", 1),
    priceTon: showTablePrice(row, "priceTon", 1),
    minPrice: row.minPrice,
    cbmKgsRatio: str(row.cbmKgsRatio, "-", "1:${}"),
    payFlag: row.payFlag,
    currencyName: "USD",
    rtLowerLimit: row.rtLowerLimit,
    rtTopLimit: row.rtTopLimit,
    customerType: row.customerType,
    payType: 0
  };
  transferRow = {
    text: "二程转运费",
    textEn: "Transhipment fee",
    priceCbm: showTablePrice(row, "ltPriceCbm", 2, "ltCurrencyName"),
    minPrice: row.ltMinPrice,
    minAmount: row.ltMinAmount, // MI
    cbmKgsRatio: str(row.ltCbmKgsRatio, "", "1:${}"),
    payFlag: row.ltPayFlag,
    currencyName: row.ltCurrencyName,
    isTransfer: true,
    rtLowerLimit: row.ltRtLowerLimit,
    rtTopLimit: row.ltRtTopLimit,
    customerType: row.secondCustomerType,
    payType: 0
  };
  list = [seaTableRow];
  if (hasTransportation(row)) {
    list.push(transferRow);
  }
  console.log("==========handle sea list", list);
  return list;
}

// 网站列表价格单位显示
export function showTableUnitPrice(row, priceKey, type = 1, currency) {
  let resObj = {
    unit: "",
    value: ""
  };
  let resPrice = "";
  // type 1一程 2二程/前置仓 currency币种
  if (type == 1) {
    if (hasTransportationFixedCharge(row)) {
      if (priceKey === "priceCbm") {
        resPrice = row.transferPrice;
      } else if (priceKey === "priceTon") {
        resPrice = row.transferPriceTon;
      }
    } else {
      resPrice = row[priceKey];
    }
    resObj = {
      unit: "USD",
      value: str(negativeFormat(resPrice), "", "${}")
    };
  } else if (type == 2) {
    let resPrice = row[priceKey];
    resObj = str(resPrice, "", row[currency] + " ${}");
    resObj = {
      unit: row[currency],
      value: str(negativeFormat(resPrice), "", "${}")
    };
  }
  return resObj;
}

// 展示费用中英文名 如过中文名无中文，则仅显示英文，如英文名不存在，则显示中文
export const showChargeNameCnEn = (
  data,
  cnKey = "chargeName",
  enKey = "chargeEn"
) => {
  let cn = data[cnKey];
  let en = data[enKey];
  let reg = new RegExp("[\\u4E00-\\u9FA5]+", "g");
  if (reg.test(cn)) {
    // 存在中文字符
    if (en) {
      return cn + "(" + en + ")";
    } else {
      return cn || "";
    }
  } else {
    // 无中文
    if (en) {
      return en;
    } else {
      return cn || "";
    }
  }
};
export const priceJoinUnit = (
  data,
  pk = "price",
  uk = "unitName",
  options = { neg: false }
) => {
  let p = data[pk];
  let u = data[uk];
  if (isInputEmpty(p) || isInputEmpty(u)) {
    return "";
  } else {
    return `${options.neg ? negativeFormat(p) : p}/${u}`;
  }
};

// ============================================================ 前置仓 START
// 是否存在前置仓，true存在
export const hasForward = (detail, source) => {
  return +detail.isForward === 1;
};
export const hasForwardAndNoZero = (detail, source) => {
  if (hasForward(detail)) {
    // 进一步判断价格
    if (detail.forwardPrice === 0) {
      return false;
    } else return true;
  } else return false;
};

export const getWarehouseShowList = (detail = {}, $locale = "cn") => {
  let list = [];
  if (detail.warehouseList && detail.warehouseList.length > 0) {
    // use pre po warehouse
    list = detail.warehouseList.map(item => {
      return {
        nameCn:
          str(item.warehouseName) + str(item.warehouseAddress, "", "(${})"),
        nameEn:
          str(item.warehouseNameEn || item.warehouseName) +
          str(item.warehouseAddressEn || item.warehouseAddress, "", "(${})"),
        fileUrl: item.warehouseUrl
      };
    });
  } else {
    // use first warehouse
    list = [
      {
        nameCn:
          str(detail.warehouseName) + str(detail.warehouseAddress, "", "(${})"),
        nameEn:
          str(detail.warehouseNameEn || detail.warehouseName) +
          str(
            detail.warehouseAddressEn || detail.warehouseAddress,
            "",
            "(${})"
          ),
        fileUrl: detail.fileUrl
      }
    ];
  }
  // translate
  list = list.map(item => ({
    ...item,
    name: $locale === "cn" ? item.nameCn : item.nameEn
  }));
  return list;
};

// 获取全流程 返回 1,1,1,1 用于switch ，包含了一程中转
export function allProcessStr(detail) {
  let process = [
    hasForward(detail) ? 1 : 0,
    1,
    firstHasTransfer(detail) ? 1 : 0,
    hasTransportation(detail) ? 1 : 0
  ];
  return process.join(",");
}
function _addOceanStart(detail, locale = "cn") {
  let showStr = "";
  // 有前置仓，则显示下一程起运港
  if (locale === "cn") {
    showStr = `起运港:${detail.portStartNameEn};`;
  } else {
    showStr = `POL:${detail.portStartNameEn};`;
  }
  return showStr;
}
// 全流程的一些关键信息
export function allProcessDetail(detail, locale = "cn") {
  let process = allProcessStr(detail);
  let res = {
    inList: {
      openProcessPopover: false, // 能否打开全流程弹窗
      isTransferName: "", // 直拼/转拼
      isTransferNameEn: "",
      transferPort: ""
    },
    inDetail: {
      // 报价单详情显示
      oceanStart: "",
      transStr: "",
      voyage: joinVoyageList(
        [detail.forwardVoyage, detail.voyage, detail.ltVoyage],
        locale
      ),
      joinShow: ""
    }
  };
  switch (process) {
    // 单程
    case "0,1,0,0": {
      res.inList.openProcessPopover = false;
      res.inList.isTransferName = "直拼";
      res.inList.isTransferNameEn = "DIR";
      res.inList.transferPort = "";
      res.inDetail.transStr = locale === "cn" ? "直拼" : " Direct";
      break;
    }
    case "0,1,1,0": {
      res.inList.openProcessPopover = false;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = str(detail.transferPortnameEn);
      res.inDetail.transStr =
        str(detail.transferPortnameEn) +
        (locale === "cn" ? "转拼" : " Transfer");

      break;
    }
    // 仅前置仓
    case "1,1,0,0": {
      res.inList.openProcessPopover = true;
      res.inList.isTransferName = "直拼";
      res.inList.isTransferNameEn = "DIR";
      res.inList.transferPort = "";
      res.inDetail.transStr = locale === "cn" ? "直拼" : " Direct";
      res.inDetail.oceanStart = _addOceanStart(detail, locale);
      break;
    }
    case "1,1,1,0": {
      res.inList.openProcessPopover = true;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = str(detail.transferPortnameEn);
      res.inDetail.transStr =
        str(detail.transferPortnameEn) +
        (locale === "cn" ? "转拼" : " Transfer");

      res.inDetail.oceanStart = _addOceanStart(detail, locale);
      break;
    }
    // 仅二程
    case "0,1,0,1": {
      res.inList.openProcessPopover = false;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = str(detail.ltTransferName);
      res.inDetail.transStr =
        str(detail.ltTransferName) + (locale === "cn" ? "转拼" : " Transfer");
      break;
    }
    case "0,1,1,1": {
      res.inList.openProcessPopover = true;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = "";
      res.inDetail.transStr =
        str(detail.transferPortnameEn, "", "${},") +
        str(detail.ltTransferName) +
        (locale === "cn" ? "转拼" : " Transfer");
      break;
    }
    // forward+second
    case "1,1,0,1": {
      res.inList.openProcessPopover = true;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = str(detail.ltTransferName);
      res.inList.transferPort = str(detail.ltTransferName);
      res.inDetail.transStr =
        str(detail.ltTransferName) + (locale === "cn" ? "转拼" : " Transfer");
      res.inDetail.oceanStart = _addOceanStart(detail, locale);

      break;
    }
    case "1,1,1,1": {
      res.inList.openProcessPopover = true;
      res.inList.isTransferName = "转拼";
      res.inList.isTransferNameEn = "VIA";
      res.inList.transferPort = "";
      res.inDetail.transStr =
        str(detail.transferPortnameEn, "", "${},") +
        str(detail.ltTransferName) +
        (locale === "cn" ? "转拼" : " Transfer");

      res.inDetail.oceanStart = _addOceanStart(detail, locale);
      break;
    }
    default: {
      break;
    }
  }
  res.inDetail.joinShow = [
    res.inDetail.oceanStart,
    res.inDetail.transStr,
    res.inDetail.voyage
  ]
    .filter(item => !isInputEmpty(item))
    .join(" ");
  // console.log("==========allProcessDetail res", res);
  return res;
}

// 海运一程存在中转
export const firstHasTransfer = detail => {
  if (+detail.transferFlag === 1) {
    return false;
  } else if (+detail.transferFlag === 2) {
    return true;
  }
  return false;
};
// 获取仓库id
export const getWarehouseId = detail => {
  if (detail.warehouseList && detail.warehouseList.length > 0) {
    return detail.warehouseList.map(item => item.warehouseId).join(",");
  } else if (!isInputEmpty(detail.warehouseId)) {
    return detail.warehouseId;
  } else return "";
};

// 报价单详情首行的港口--港口
export const quoDetailPort2Port = (detail, $locale = "cn") => {
  let start = {
    nameEn: "",
    nameCn: "",
    countryEn: "",
    countryCn: ""
  };
  if (hasForward(detail)) {
    // use  name
    start = {
      nameEn: detail.forwardStartNameEn,
      nameCn: detail.forwardStartNameCn,
      countryEn: detail.forwardStartCountryCode,
      countryCn: detail.forwardStartCountryName
    };
  } else {
    // use first ocean name
    start = {
      nameEn: detail.portStartNameEn,
      nameCn: detail.portStartNameCn,
      countryEn: detail.portStartCountryCode,
      countryCn: detail.portStartCountryName
    };
  }
  let end = {
    nameEn: "",
    nameCn: "",
    countryEn: "",
    countryCn: ""
  };
  if (hasTransportation(detail)) {
    // use second end name
    end = {
      nameEn: detail.ltPortDestNameEn,
      nameCn: detail.ltPortDestNameCn,
      countryEn: detail.ltPortDestCountryCode,
      countryCn: detail.ltPortDestCountryName
    };
  } else {
    // use first ocean end name
    end = {
      nameEn: detail.portEndNameEn,
      nameCn: detail.portEndNameCn,
      countryEn: detail.portEndCountryCode,
      countryCn: detail.portEndCountryName
    };
  }
  let showStr = "";
  if ($locale === "cn") {
    showStr =
      `${str(start.nameEn)}(${str(start.countryCn)}.${str(start.nameCn)})` +
      ` -- ` +
      `${str(end.nameEn)}(${str(end.countryCn)}.${str(end.nameCn)})`;
  } else {
    showStr =
      `${str(start.nameEn)}(${str(start.countryEn)})` +
      ` -- ` +
      `${str(end.nameEn)}(${str(end.countryEn)})`;
  }
  return {
    start,
    end,
    showStr
  };
};
// 获取处理后的start name 都是携带码头的
export const getStartInList = (detail, source = "") => {
  let res = {
    nameCn: "",
    nameEn: ""
  };
  if (hasForward(detail)) {
    // use pre po wh name
    res.nameCn = detail.forwardStartNameCn;
    res.nameEn = detail.forwardStartNameEn;
  } else {
    // use first ocean name
    res.nameCn = detail.portStartNameCn;
    res.nameEn = detail.portStartNameEn;
  }

  return res;
};
export const getEndInList = (detail, source = "") => {
  let res = {
    nameCn: "",
    nameEn: ""
  };
  if (hasTransportation(detail)) {
    // use second name
    res.nameCn = detail.ltPortDestNameCn;
    res.nameEn = detail.ltPortDestNameEn;
  } else {
    // use first ocean name
    res.nameCn = detail.portEndNameCn;
    res.nameEn = detail.portEndNameEn;
  }
  return res;
};
// ============================================================ 前置仓 END

// 处理起运港/运费附加费的备注拼接
export const handleStartChargeRemark = (
  charge,
  remarkKey = "chargeRemark",
  locale = "cn"
) => {
  let remark = charge[remarkKey] || "";
  let list = [remark];
  if (+charge.singlePolling === 1) {
    // 单询
    list.unshift(locale === "cn" ? "单询" : "Inquiry");
  }
  let res = list.filter(item => !isInputEmpty(item)).join(",");
  return res;
};
// 处理目的港的备注拼接
export const handleEndChargeRemark = (
  charge,
  remarkKey = "remark",
  locale = "cn"
) => {
  let remark = charge[remarkKey] || "";
  let list = [remark];
  if (+charge.calculateFlag === 3) {
    list.unshift("AS ACTUAL");
  }
  let res = list.filter(item => !isInputEmpty(item)).join(",");
  return res;
};
// 3是BL,4是RT
export const extremeShow = (value, unitId, unitStr) => {
  if (isInputEmpty(value)) return "";
  if (unitId) {
    if (+unitId === 3) {
      return `${value}/BL`;
    } else if (+unitId === 4) {
      return `${value} RT`;
    } else {
      return value;
    }
  }
  if (unitStr) {
    if (unitStr === "BL") {
      return `${value}/BL`;
    } else if (unitStr === "RT") {
      return `${value} RT`;
    } else {
      return value;
    }
  }
  return value;
};

export const showCustomerTypeName = (type, locale = "cn") => {
  if (!type) {
    let node = maintainConsigneeOptions.find(item => item.id === 3);
    return locale === "cn" ? node.name : node.nameEn;
  }
  let node = byKey(maintainConsigneeOptions, type);
  return locale === "cn" ? node.name : node.nameEn;
};

export const getSeaChargeRemark = (detail, locale = "cn") => {
  if (detail.customerType === 1) {
    return detail.surachrgeFreightColoaderRemark || "";
  } else if (detail.customerType === 2) {
    return detail.surachrgeFreightDirectRemark || "";
  } else return "";
};
export const getStartChargeRemark = (detail, locale = "cn") => {
  if (detail.customerType === 1) {
    return detail.surachrgeStartColoaderRemark || "";
  } else if (detail.customerType === 2) {
    return detail.surachrgeStartDirectRemark || "";
  } else return "";
};
export const getEndChargeRemark = (detail, locale = "cn") => {
  if (detail.customerType === 1) {
    return detail.surachrgeEndColoaderRemark || "";
  } else if (detail.customerType === 2) {
    return detail.surachrgeEndDirectRemark || "";
  } else return "";
};

export const showCostRule = (
  data,
  price = "price",
  chargeUnitStr = "chargeUnitStr",
  chargeUnitRadix = "chargeUnitRadix"
) => {
  let priceRow = data[price] || "";//价格
  let unitRow = data[chargeUnitStr] || "";//单位
  let RadixRow = data[chargeUnitRadix] || "";//费用单位
  if (isInputEmpty(priceRow) || isInputEmpty(unitRow)) {
    return ""
  }
  if(unitRow == '%'){
    return `${priceRow}${unitRow}`
  }else if(RadixRow == 1){
    return `${priceRow}/${unitRow}`
  }else {
    return `${priceRow}/${RadixRow}${unitRow}`
  }
};
export const showPercentageRule = (
  data,
  price = "price",
  unitName = "unitName",
) => {
  let priceRow = data[price] || "";//价格
  let unitRow = data[unitName] || "";//单位
  if (isInputEmpty(priceRow) || isInputEmpty(unitRow)) {
    return false
  }
  if(unitRow === '%'){
    return `${priceRow}${unitRow}`
  }else {
    return false
  }
};